// utils/formatDni.js

/** Deja solo dígitos, recortado a 10 (uso interno/validación/payload). */
export function cleanDni(value) {
  return String(value || "").replace(/\D/g, "").slice(0, 10);
}

/** Formatea dígitos como DNI (ej: "30222001" -> "30.222.001") solo para mostrar. */
export function formatDni(value) {
  return cleanDni(value).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
